/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Grade_10_Or_Lower12Inputs */

const en__field_enum_grade_10_or_lower12 = /** @type {(inputs: _Field_Enum_Grade_10_Or_Lower12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade 10 or lower`)
};

const de__field_enum_grade_10_or_lower12 = /** @type {(inputs: _Field_Enum_Grade_10_Or_Lower12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Klasse oder niedriger`)
};

/**
* | output |
* | --- |
* | "Grade 10 or lower" |
*
* @param {_Field_Enum_Grade_10_Or_Lower12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_grade_10_or_lower12 = /** @type {((inputs?: _Field_Enum_Grade_10_Or_Lower12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Grade_10_Or_Lower12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_grade_10_or_lower12(inputs)
	return de__field_enum_grade_10_or_lower12(inputs)
});
export { _field_enum_grade_10_or_lower12 as "_field_enum_GRADE_10_OR_LOWER" }